import React from 'react';
import styles from './visually-hidden.css';
const VisuallyHidden = ({ children, ...props }) => {
    return (React.createElement("div", { className: styles.root, ...props }, children));
};
export default VisuallyHidden;
//# sourceMappingURL=visually-hidden.js.map